module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-layout', {
    staticClass: "ql-pages-container",
    attrs: {
      "md-flex": "100",
      "md-column": ""
    }
  }, [_c('md-layout', {
    staticClass: "ql-page-layout",
    attrs: {
      "md-row": "",
      "md-gutter": "12"
    }
  }, [(_vm.pageReady) ? _c('svg', {
    staticClass: "ql-page-graphics",
    style: ({
      height: (_vm.svgTrueHeight + "px")
    }),
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "version": "1.1",
      "height": _vm.svgTrueHeight
    }
  }, _vm._l((_vm.positionedCues), function(cue) {
    return _c('line', {
      attrs: {
        "x1": cue.offsetX + cue.width,
        "y1": _vm.cuePosTop(cue),
        "x2": _vm.svgOffsetEnd,
        "y2": cue.offsetY,
        "stroke": _vm.cueColor(cue),
        "stroke-width": "1"
      }
    })
  })) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "70"
    }
  }, _vm._l((_vm.pages), function(page, index) {
    return (_vm.current(index + 1)) ? _c('project-page', {
      key: index,
      attrs: {
        "page": page,
        "cues": _vm.visibleCues(index + 1),
        "layers": _vm.visibleLayers,
        "currentLayer": _vm.currentLayer,
        "locked": _vm.locked,
        "showMode": _vm.showMode
      },
      on: {
        "pageLoaded": _vm.pageLoaded,
        "addedCue": _vm.addedCue,
        "deletedCue": _vm.deletedCue,
        "updatedCue": _vm.updatedCue
      }
    }) : _vm._e()
  })), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('project-cue-list', {
    attrs: {
      "cues": _vm.positionedCues,
      "layers": _vm.visibleLayers,
      "locked": _vm.locked,
      "openCues": _vm.openCues
    },
    on: {
      "openCue": _vm.openCue,
      "closeCue": _vm.closeCue,
      "destroy": _vm.deletedCue,
      "updatedCue": _vm.updatedCue
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e3fcace","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sample/components/project/pages.vue
// module id = 660
// module chunks = 2